var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Cascader',{attrs:{"data":_vm.regionArr,"disabled":_vm.cascaderDisabled},on:{"on-change":_vm.onChangeCascader},model:{value:(_vm.cascaderArr),callback:function ($$v) {_vm.cascaderArr=$$v},expression:"cascaderArr"}})}
var staticRenderFns = []

export { render, staticRenderFns }